<template>
  <div >
    <div style="border-bottom: 1px solid #e7e5e5;line-height: 1.41176471;padding-bottom: 8px;">
     
      <font style="color: red;" v-if="tb.ismust">*</font>
       <font style="color: red;" v-else="tb.ismust">&nbsp </font>
       {{tb.name}}</div>
      
      <br>
 
  <div style="display: flex;justify-content: center;justify-content: center;background-color: white;">
    <div ref="canvasHW" style="height: 300px;width: 95%;position: relative;">
      <div
        style="text-align: center;position: absolute;left:0;bottom: 0;right: 0;top: 0;margin: auto;width: 100px;height: 20px;color: gray;pointer-events:none;">
        {{tb.name}}</div>
        <div style="position: absolute;left:0;right:0;top:0;bottom: 0;border:dashed 1px #c0baba3f;pointer-events:none;">

        </div>
      <a v-if="tb.val" @click="overwrite" style="position: absolute;right: 0;"><i class="weui-icon-clear"></i></a>
      <canvas @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" ref="canvasF" @mousedown="mouseDown"
        @mousemove="mouseMove" @mouseup="mouseUp" ></canvas>

      <!--   <button @click="buildpic">生成图片</button> -->
    </div>
  </div>

 
  


    <br>


  </div>
</template>

<script>
  export default {
    props: ['tb'],
    name: 'Sign',
    data() {
      return {
        points: [],
        canvasTxt: null,
        startX: 0,
        startY: 0,
        moveY: 0,
        moveX: 0,
        endY: 0,
        endX: 0,
        w: null,
        h: null,
        isDown: false,
        color: "#000",
        linewidth: 3,
        isDraw: false //签名标记
      }
    },

    mounted() {
      let canvas = this.$refs.canvasF;
      canvas.height = this.$refs.canvasHW.offsetHeight;
      canvas.width = this.$refs.canvasHW.offsetWidth;
      this.canvasTxt = canvas.getContext("2d");
      this.canvasTxt.fillStyle = "#fdfffd";
      this.canvasTxt.fillRect(0, 0, canvas.width-2, canvas.height-2 );

      this.canvasTxt.strokeStyle = this.color;
      this.canvasTxt.lineWidth = this.linewidth;

    },
    computed: {
      all() {
        var img = this.$refs.canvasF.toDataURL();
        console.log(img);
        return img;
      }
    },
    methods: {
      touchStart(ev) {
        ev = ev || event;
        ev.preventDefault();

        if (ev.touches.length == 1) {

          this.isDraw = true; //签名标记
          let obj = {
            x: ev.targetTouches[0].pageX-60,
            y: ev.targetTouches[0].pageY - this.$refs.canvasHW.offsetTop
          }; //y的计算值中：document.body.offsetHeight*0.5代表的是除了整个画板signatureBox剩余的高，this.$refs.canvasHW.offsetHeight*0.1是画板中标题的高
          this.startX = obj.x;
          this.startY = obj.y;
          this.canvasTxt.beginPath(); //开始作画
          this.points.push(obj); //记录点

        }
      },

      mouseDown(ev) {
        ev = ev || event;
        ev.preventDefault();

        let obj = {
          x: ev.offsetX,
          y: ev.offsetY
        };
        this.startX = obj.x;
        this.startY = obj.y;
        this.canvasTxt.beginPath(); //开始作画
        this.points.push(obj); //记录点
        this.isDown = true;
      },
      mouseMove(ev) {
        ev = ev || event;
        ev.preventDefault();

        if (this.isDown) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          };
          this.moveY = obj.y;
          this.moveX = obj.x;
          this.canvasTxt.moveTo(this.startX, this.startY); //移动画笔
          this.canvasTxt.lineTo(obj.x, obj.y); //创建线条
          this.canvasTxt.stroke(); //画线
          this.startY = obj.y;
          this.startX = obj.x;
          this.points.push(obj); //记录点
        }
      },
      touchMove(ev) {
        ev = ev || event;
        ev.preventDefault();
      
        if (ev.touches.length == 1) {

          let obj = {
            x: ev.targetTouches[0].pageX-60,
            y: ev.targetTouches[0].pageY - this.$refs.canvasHW.offsetTop
          };
          this.moveY = obj.y;
          this.moveX = obj.x;
          this.canvasTxt.moveTo(this.startX, this.startY); //移动画笔
          this.canvasTxt.lineTo(obj.x, obj.y); //创建线条
          this.canvasTxt.stroke(); //画线
          this.startY = obj.y;
          this.startX = obj.x;
          this.points.push(obj); //记录点
        }
      },
      mouseUp(ev) {
        ev = ev || event;
        ev.preventDefault();
        if (1) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          };
    
          
          this.canvasTxt.closePath(); //收笔
          this.points.push(obj); //记录点
          this.points.push({
            x: -1,
            y: -1
          });
          this.isDown = false;
        }
        var img = this.$refs.canvasF.toDataURL();
        this.tb.val = img;
      },
      touchEnd(ev) {
        ev = ev || event;
        ev.preventDefault();

        if (ev.touches.length == 1) {

          let obj = {
            x: ev.targetTouches[0].clientX,
            y: ev.targetTouches[0].clientY
          };
          this.canvasTxt.closePath(); //收笔
          this.points.push(obj); //记录点
          this.points.push({
            x: -1,
            y: -1
          }); //记录点
        }
        var img = this.$refs.canvasF.toDataURL();
        this.tb.val = img;
      },
      overwrite() {
        this.canvasTxt.clearRect(
          0,
          0,
          this.$refs.canvasF.width,
          this.$refs.canvasF.height
        );
        let canvas = this.$refs.canvasF;
        this.canvasTxt.fillStyle = "#fdfffd";
        this.canvasTxt.fillRect(0, 0, canvas.width - 2, canvas.height - 2);
        this.points = [];
        this.isDraw = false; //签名标记
        this.tb.val="";
      },
      buildpic() {
        var img = this.$refs.canvasF.toDataURL();

        return {
          img
        };
      }
    }

  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  * {
    margin: 0;
    padding: 0;
    
  }

</style>



// WEBPACK FOOTER //
// src/fields/Sign.vue